import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Row, Anchor, Body, Card } from '@sumup/circuit-ui';
import { ChevronRight } from '@sumup/icons';

import { StyledComponentsParams } from 'types/components';

export const ArticleChevron = styled(ChevronRight)(
  ({ theme }: StyledComponentsParams) => css`
    color: var(--cui-bg-accent-strong);
    margin-left: ${theme.spacings.kilo};
  `,
);

export const ArticleDescription = styled(Body)(
  ({ theme }: StyledComponentsParams) => css`
    margin-bottom: ${theme.spacings.mega};
    overflow: hidden;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `,
);

export const ReadArticleLink = styled(Anchor)(
  ({ theme }: StyledComponentsParams) => css`
    display: flex;
    align-items: center;
    text-decoration: none;
    color: var(--cui-bg-accent-strong);
    &:visited,
    &:visited:active,
    &:visited:hover,
    &:hover,
    &:active,
    &:focus {
      color: var(--cui-bg-accent-strong);
    }

    svg {
      margin-left: ${theme.spacings.byte};
      transform: translateX(0);
      transition: all 0.18s ease-in-out;
    }

    :hover {
      svg {
        transform: translateX(5px);
      }
    }
  `,
);

export const SectionArticlesItem = styled(Card)(
  ({ theme }: StyledComponentsParams) => css`
    ${theme.mq.untilMega} {
      margin-bottom: ${theme.spacings.mega};
    }
    ${theme.mq.mega} {
      margin-bottom: ${theme.spacings.giga};
    }
  `,
);

export const SectionsContainer = styled(Row)(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: ${theme.spacings.mega};
  `,
);
